$(".menu-toggle").on("click", function () {
	$(".menu-wrapper").slideToggle();
});

$("header").sticky({
    topSpacing: 0,
    zIndex: 50,
});